# Global data
export state = ->
	mobileMenuOpen: false
	menuOpen: false

export mutations =
	setMobileMenuOpen: (state, open) -> state.mobileMenuOpen = open
	setMenuOpen: (state, open) -> state.menuOpen = open

